export default "__VITE_ASSET__CcUyCsmO__"